import * as z from "zod";
import { shopperAgentTestStatus } from "./shopper-agent-test-status";

/** A test kind in code: what a test row can vary. */
const shopperAgentTestKind = z.object({
  kind: z.string(),
  /** The arm results compare every other arm with. */
  control: z.string(),
  arms: z.array(z.object({ arm: z.string(), description: z.string() })),
});

export type ShopperAgentTestKind = z.infer<typeof shopperAgentTestKind>;

export const getShopperAgentTests = {
  name: "getShopperAgentTests" as const,
  input: z.object({}),
  output: z.object({
    kinds: z.array(shopperAgentTestKind),
    /** The live test of every kind in code and the 20 newest, newest first. Kinds out of code are left out. */
    tests: z.array(shopperAgentTestStatus),
  }),
};
